// extracted by mini-css-extract-plugin
export default {"wrapper":"NeedHelpSection_wrapper--d1N","icon":"NeedHelpSection_icon--CN3"};